import { useSelector } from "react-redux";

import type { RootState } from "newui/store";
import type { Company, CorporateDocument, PastProject } from "newui/features/Company/types";

interface CompanyPreviewData {
	company: Company | null;
	documents: CorporateDocument[];
	pastProjects: PastProject[];
	isLoading: boolean;
	profileTypeId: number | null;
}

export const useCompanyPreviewData = (): CompanyPreviewData => {
	const company = useSelector(
		(state: RootState) => state.search.activeCompany as Company | null
	);
	const documents = useSelector(
		(state: RootState) =>
			(state.companyProfile.documents as CorporateDocument[]) ?? []
	);
	const pastProjects = useSelector(
		(state: RootState) =>
			(state.companyProfile.pastProjects as PastProject[]) ?? []
	);
	const isLoading = useSelector(
		(state: RootState) => state.search.isLoading as boolean
	);

	const profileTypeId = company?.profile_type?.id ?? null;

	return { company, documents, pastProjects, isLoading, profileTypeId };
};
